/** Gold pin used for the JPB search-area / buffer point layer (matches map `icon-image` suffix). */
export const JPB_BUFFER_POINT_PIN_COLOR = "#d6c251";

let bufferPointLayerId: number | undefined;
const listeners = new Set<() => void>();

export function setJpbBufferPointLegendLayerId(layerId: number | undefined): void {
   if (bufferPointLayerId === layerId) {
      return;
   }
   bufferPointLayerId = layerId;
   for (const l of listeners) {
      l();
   }
}

export function getJpbBufferPointLegendLayerId(): number | undefined {
   return bufferPointLayerId;
}

export function subscribeJpbBufferPointLegend(onStoreChange: () => void): () => void {
   listeners.add(onStoreChange);
   return () => listeners.delete(onStoreChange);
}
